import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState, useEffect } from 'react';
import { Tab, Tabs, Row, Col } from 'react-bootstrap';
import ClaimDashboard from '@components/shared/claim/ClaimDashboard';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { fetchAndSetAdmins, fetchAndSetConsultants } from 'src/effects/user.effects';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useSelector } from 'react-redux';
const NavigationTabs = _ref => {
  let {
    accountType,
    sendClientCostEmail,
    claimGroup,
    company,
    onClaimGroupUpdate,
    loading,
    currentClaimCostId,
    handleImportCostTemplate,
    createChangeSet,
    finalizeChangeSet,
    handleToaster,
    approveChangeSet,
    rejectChangeSet,
    createChangeSetsForAllClaimsInClaimGroup
  } = _ref;
  const history = useHistory();
  const dispatch = useDispatch();
  const [consultants, setConsultants] = useState(null);
  const [admins, setAdmins] = useState(null);
  const [key, setKey] = useState(-1);
  const user = useSelector(state => state.auth.user);
  useEffect(() => {
    fetchAndSetConsultants(setConsultants, dispatch, handleError);
    fetchAndSetAdmins(setAdmins, dispatch, handleError);
  }, [claimGroup.id, dispatch]);
  useEffect(() => {
    setKey(currentClaimCostId);
  }, [currentClaimCostId]);
  const handleAddClaimToGroup = claimId => {
    if (+claimId === -1) {
      history.push("/".concat(accountType, "/add_claim/company/").concat(company.id_in_provider_system, "/claim_groups/").concat(claimGroup.id));
    }
    setKey(claimId);
  };
  if (!consultants || !admins) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(Tabs, {
    onSelect: e => handleAddClaimToGroup(e),
    activeKey: key,
    defaultActiveKey: claimGroup.claims[0] || -1,
    transition: false,
    className: "mb-3"
  }, (claimGroup.claims || []).filter(claim => claim.id_in_provider_system).map(claim => {
    return /*#__PURE__*/React.createElement(Tab, {
      eventKey: claim.id,
      title: claim.name
    }, /*#__PURE__*/React.createElement(ClaimDashboard, {
      accountType: accountType,
      sendClientCostEmail: sendClientCostEmail,
      claim: claim,
      claimGroup: claimGroup,
      company: company,
      consultantsAndAdmins: [...consultants, ...admins],
      onClaimGroupUpdate: onClaimGroupUpdate,
      loading: loading,
      handleImportCostTemplate: handleImportCostTemplate,
      createChangeSet: createChangeSet,
      finalizeChangeSet: finalizeChangeSet,
      approveChangeSet: approveChangeSet,
      rejectChangeSet: rejectChangeSet,
      handleToaster: handleToaster,
      createChangeSetsForAllClaimsInClaimGroup: createChangeSetsForAllClaimsInClaimGroup
    }));
  }), user.account_type !== 'customer' && /*#__PURE__*/React.createElement(Tab, {
    eventKey: -1,
    title: 'Add Claim'
  }, /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5 text-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-muted"
  }, "No previous claims", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/add_claim/company/").concat(company.id_in_provider_system, "/claim_groups/").concat(claimGroup.id)
  }, "Import Claims"))))));
};
export default NavigationTabs;